import { useMutation } from '@tanstack/react-query';
import { createUrl } from 'src/core/api/utils/createUrl';
import { fetch as fetchRedirect } from 'src/utils/refetch';

const useMoviePurchaseMutation = (id: string) => {
  const { mutate, isLoading } = useMutation({
    mutationFn: async (data: any) => {
      const response = await fetchRedirect(createUrl(`/movies/${id}/purchase`), {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'sky-token': localStorage.getItem('sky_token') || '',
          'sky-refresh-token': localStorage.getItem('sky_refresh_token') || '',
        },
      });
      if (!response.response.ok) {
        return response.body;
      }
      return response.body;
    },
  });
  return { mutate, isLoading };
};

export default useMoviePurchaseMutation;
